module.exports = __webpack_public_path__ + "img/组屋.3a4d27b1.jpg";